import { PiuApplication, PiuMatrix, PiuOverview } from '@/common/model/productInfoUsage'

export const ProductInfoUsageApiPath = {
  OVERVIEW: '/api/sites/{site_id}/product-info-usage',
  SAVE: '/api/sites/{site_id}/product-info-usage',
  APPLY: '/api/sites/{site_id}/product-info-usage/apply',
  APPLICATIONS: '/api/sites/{site_id}/product-info-usage/applications'
} as const

export type ProductInfoUsageApiPath =
  (typeof ProductInfoUsageApiPath)[keyof typeof ProductInfoUsageApiPath]

export interface PiuOverviewVars {
  site_id: number
  history_limit?: number
}

export interface PiuSaveVars {
  site_id: number
  /** 送らなかった組み合わせは変更しない */
  matrix: PiuMatrix
}

export interface PiuApplyVars {
  site_id: number
  /** 省略すると未反映の対象をすべて実行する */
  targets?: string[]
}

export interface PiuApplicationsVars {
  site_id: number
  limit?: number
}

export type PiuOverviewResponse = PiuOverview

export interface PiuSaveResponse {
  saved: boolean
  changed_count: number
  pending_targets: string[]
  last_saved_at: string | null
}

export interface PiuApplyResponse {
  started: boolean
  application: PiuApplication
}

export type PiuApplicationsResponse = PiuApplication[]
